/* eslint-disable */
import React from "react";
import Brandfolder from "./brandfolder";
import _ from "underscore";

export default class BrandfolderList extends React.Component {
    state = {
        loading: true,
        error: false,
        brandfolders: []
    };

    componentDidMount() {
        this.getBrandfolders();
    }

    getBrandfolders() {
        return $.ajax({
            url: "/api/v4/brandfolders",
            type: "GET",
            context: this,
            headers: { Authorization: `Bearer ${this.props.jwt}` },
            success: function(response) {
                let brandfolders = _.sortBy(response.data, brandfolder =>
                    brandfolder.attributes.name.toUpperCase()
                );
                this.setState({ loading: false, brandfolders: brandfolders });
            }
        });
    }

    renderBackButtonOrNotification() {
        if (!!this.props.selected_brandfolder) {
            return (
                <div
                    className="adobe-brandfolder-list-header"
                    onClick={this.props.toggleBrandfolderList}
                >
                  <p><span className="bff-arrow-left" />Back to Menu</p>
                </div>
            );
        } else {
            return (
                <div className="adobe-brandfolder-list-header">
                    <p>Select a Brandfolder</p>
                </div>
            );
        }
    }

    renderBrandfolders() {
        if (!!this.state.loading) {
            return (
                <div className="adobe-notification">
                  <img
                    alt="loading icon"
                    className="bff-spinner-gif"
                    src="https://cdn.brandfolder.io/27C9EC93/at/qdh7e1-cbakhk-47987g/bff-spinner.gif"
                  />
                </div>
            );
        } else if (!!this.state.error) {
            return (
                <div className="adobe-notification">
                  <span className="bff-warning" />
                  <p>Unable to load Brandfolders at this time</p>
                </div>
            );
        } else if (this.state.brandfolders.length === 0) {
            return (
                <div className="adobe-notification">
                  <span className="bff-comment" />
                  <p>No Brandfolders to choose from</p>
                </div>
            );
        } else {
            const brandfolders = this.state.brandfolders;
            const brandfolder_list = brandfolders.map(brandfolder => {
                return (
                    <li
                        key={brandfolder.id}
                        onClick={() =>
                            this.props.selectBrandfolder(brandfolder)
                        }
                    >
                        <Brandfolder
                            brandfolder={brandfolder.attributes}
                        />
                    </li>
                );
            });
            return <ul>{brandfolder_list}</ul>;
        }
    }

    render() {
        return (
            <div>
                {this.renderBackButtonOrNotification()}
                <div className="adobe-brandfolder-list">
                    {this.renderBrandfolders()}
                </div>
            </div>
        );
    }
}
